import { Link } from 'react-router-dom'
import { TOOL_LINKS } from '../../content/tools'
import { ROUTES } from '../../lib/routes'

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-slate-950/70">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-12 sm:px-6 lg:px-8 md:grid-cols-3">
        <div className="space-y-3">
          <div className="text-base font-semibold tracking-tight text-white">Instant PDF Tools</div>
          <p className="text-sm text-slate-300">Fast, private PDF tools—right in your browser.</p>
          <p className="text-xs text-slate-400">
            Use at your own discretion and risk. Always review outputs before relying on them. By using this service, you acknowledge that we are not liable for any errors or damages. See our Terms of Service for details.
          </p>
        </div>

        <div className="grid gap-2 text-sm text-slate-300 md:col-span-2 md:grid-cols-2">
          <div className="space-y-2">
            <div className="text-xs font-semibold uppercase tracking-wide text-slate-400">Tools</div>
            <ul className="grid gap-1">
              <li>
                <Link to={ROUTES.tools} className="hover:text-white font-medium">
                  All Tools
                </Link>
              </li>
              {TOOL_LINKS.map((t) => (
                <li key={t.href}>
                  <Link to={t.href} className="hover:text-white">
                    {t.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="space-y-2">
            <div className="text-xs font-semibold uppercase tracking-wide text-slate-400">Company</div>
            <ul className="grid gap-1">
              <li>
                <Link to={ROUTES.about} className="hover:text-white">
                  About
                </Link>
              </li>
              <li>
                <Link to={ROUTES.privacy} className="hover:text-white">
                  Privacy policy
                </Link>
              </li>
              <li>
                <Link to={ROUTES.terms} className="hover:text-white">
                  Terms of service
                </Link>
              </li>
            </ul>
            <div className="pt-4 text-xs text-slate-500">© {new Date().getFullYear()} Instant PDF Tools</div>
          </div>
        </div>
      </div>
    </footer>
  )
}
